import React, { useState, useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, TextField, Checkbox, Paper, Grid, MenuItem, Container, CircularProgress, InputLabel } from '@material-ui/core';
import whatsAppService from '../../api/whatsAppService';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Icon from '@material-ui/core/Icon';
import { getSelectOptions } from '../../shared/helpers/selectHelper';

const WhatsAppScreenForm = ({ categories }) => {
    const [isSending, setIsSending] = useState(false);
    const [message, setMessage] = useState('');
    const [newDestination, setNewDestination] = useState('');
    const [destinations, setDestinations] = useState([]);
    const [sendToAll, setSendToAll] = useState(false);
    const [insertImage, setInsertImage] = useState(false);
    const [file, setFile] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubcategory, setSelectedSubcategory] = useState('');
    const [selectedGroup, setSelectedGroup] = useState('');
    const [groups, setGroups] = useState([]);
    const [countryCode, setCountryCode] = useState('');

    const [destinationsGroups, setDestinationsGroup] = useState([]);

    useEffect(() => {
        whatsAppService.getAllGroups(setGroups);
    }, []);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
    };

    const handleCountryCodeChange = (event) => {
        const selectedCountryCode = event.target.value;
        setCountryCode(selectedCountryCode);
    };

    const subcategories = useMemo(() => {
        const catSelected = categories.filter((cat) => cat.name === selectedCategory);
        if (catSelected.length <= 0) {
            return [];
        }
        return catSelected[0].subcategories;
    }, [categories, selectedCategory]);

    const sendWhatsAppMessage = () => {
        setIsSending(true);

        const valuesToSendGroups = destinationsGroups.map(group => group.value);

        whatsAppService.sendMessage(message, sendToAll, destinations, selectedCategory, selectedSubcategory, file,
            valuesToSendGroups)
            .then(() => {
                setIsSending(false);
            })
            .catch(() => {
                setIsSending(false);
            });
    };

    const isSendButtonDisabled = message.trim() === '';

    const addDestination = () => {
        if (newDestination.trim() !== '') {
            const destinationWithCountryCode = `${countryCode}${newDestination}`;
            setDestinations([...destinations, destinationWithCountryCode]);
            setNewDestination('');
        }
    };

    const removeDestination = (index) => {
        const updatedDestinations = [...destinations];
        updatedDestinations.splice(index, 1);
        setDestinations(updatedDestinations);
    };

    const addGroupToDestinationsGroup = () => {
        if (selectedGroup && selectedGroup.value.trim() !== '') {
            setDestinationsGroup([...destinationsGroups, selectedGroup]);
            setSelectedGroup(null);
        }
    };

    const removeDestinationGroup = (index) => {
        const updatedDestinationsGroup = [...destinationsGroups];
        updatedDestinationsGroup.splice(index, 1);
        setDestinationsGroup(updatedDestinationsGroup);
    };

    return (
        <Paper>
            <Container style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Typography variant='h4' margin='normal' style={{ margin: 10 }}>Send WhatsApp Message</Typography>
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                value={sendToAll}
                                onChange={({ target }) => setSendToAll(target.checked)}
                            />
                        }
                        label="Send to all users"
                        labelPlacement="end"
                        style={{ margin: 0 }}
                    />
                </div>
                {
                    !sendToAll &&
                    <>
                        <InputLabel variant='h4' margin='normal' style={{ margin: 10, color: 'rgba(9, 9, 9, 0.92)' }}>Send by Category</InputLabel>

                        <Grid container>
                            <Grid item xs={12} sm={6} style={{ padding: 5 }}>
                                <TextField select
                                    margin="normal"
                                    variant="outlined"
                                    label="Category"
                                    value={selectedCategory}
                                    onChange={({ target }) => setSelectedCategory(target.value)}
                                    fullWidth
                                >
                                    {[<MenuItem value={""}>Choose a category...</MenuItem>, getSelectOptions(categories.map((category) => ({ value: category.name, display: category.name })))]}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ padding: 5 }}>
                                <TextField select
                                    margin="normal"
                                    variant="outlined"
                                    label="Subcategory"
                                    value={selectedSubcategory}
                                    onChange={({ target }) => setSelectedSubcategory(target.value)}
                                    fullWidth
                                >
                                    {[<MenuItem value={""}>Choose a subcategory...</MenuItem>, getSelectOptions(subcategories.map((subcategory) => ({ value: subcategory.name, display: subcategory.name })))]}

                                </TextField>
                            </Grid>
                        </Grid>
                    </>
                }


                <div style={{ padding: 5, display: 'flex', alignItems: 'center' }}>
                    <TextField
                        select
                        variant="outlined"
                        margin="normal"
                        label="Group"
                        value={selectedGroup ? selectedGroup.value : ''}
                        onChange={({ target }) => setSelectedGroup(groups.find(group => group.value === target.value))}
                        style={{ flex: 0.5, marginRight: '8px' }}
                    >
                        {[<MenuItem value={""}>Choose a group...</MenuItem>, getSelectOptions(groups)]}
                    </TextField>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={addGroupToDestinationsGroup}
                        style={{ flex: 0.3 }}
                    >
                        Add Group
                    </Button>
                </div>
                <div>
                    {destinationsGroups.slice().reverse().map((destinationGroup, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                            <div style={{ padding: 5, display: 'flex', alignItems: 'center' }}>
                                <TextField
                                    label="Destination Group"
                                    variant="outlined"
                                    margin="normal"
                                    value={destinationGroup.display}
                                    disabled // Define o campo de entrada como desabilitado
                                    style={{ flex: 0.5, marginRight: '8px' }}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => removeDestinationGroup(destinationsGroups.length - 1 - index)}
                                    style={{ flex: 0.3 }}
                                >
                                    Remove
                                </Button>
                            </div>
                        </div>
                    ))}

                </div>


                <div style={{ padding: 5, display: 'flex', alignItems: 'center' }}>
                <TextField
                        select
                        variant="outlined"
                        margin="normal"
                        label="Country Code"
                        value={countryCode}
                        onChange={handleCountryCodeChange}
                        style={{ flex: 0.2, marginRight: '8px' }}
                    >
                        <MenuItem value="+1">USA (+1)</MenuItem>
                        <MenuItem value="+55">Brazil (+55)</MenuItem>
                        <MenuItem value="+52">Mexico (+52)</MenuItem>
                        <MenuItem value="+56">Chile (+56)</MenuItem>
                        <MenuItem value="+54">Argentina (+54)</MenuItem>
                        <MenuItem value="+598">Uruguay (+598)</MenuItem>
                    </TextField>
                    <TextField
                        label="New Destination"
                        variant="outlined"
                        margin="normal"
                        value={newDestination}
                        onChange={(e) => setNewDestination(e.target.value)}
                        style={{ flex: 0.3, marginRight: '8px' }} // Define o tamanho do campo de entrada
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={addDestination}
                        style={{ flex: 0.3 }} // Define o tamanho do botão para metade do tamanho do campo de entrada
                    >
                        Add
                    </Button>
                </div>
                <div>
                    {destinations.slice().reverse().map((destination, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                            <div style={{ padding: 5, display: 'flex', alignItems: 'center' }}>
                                <TextField
                                    label="Destination"
                                    variant="outlined"
                                    margin="normal"
                                    value={destination}
                                    disabled // Define o campo de entrada como desabilitado
                                    style={{ flex: 0.5, marginRight: '8px' }}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => removeDestination(destinations.length - 1 - index)}
                                    style={{ flex: 0.3 }}
                                >
                                    Remove
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ padding: 5 }}>
                    <TextField
                        label="Message Body"
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
                <div style={{ padding: 5 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                value={insertImage}
                                onChange={({ target }) => setInsertImage(target.checked)}
                            />
                        }
                        label="Insert Image"
                        labelPlacement="end"
                        style={{ margin: 0 }}
                    />
                </div>
                {insertImage && (
                    <div style={{ padding: 5 }}>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                    </div>
                )}

                <div>
                    <Button
                        variant="contained"
                        color="secondary"
                        margin="normal"
                        disabled={isSending || isSendButtonDisabled 
                            || (destinations.length === 0 && destinationsGroups.length === 0 
                                && sendToAll === false && selectedSubcategory === '')}
                        style={{ margin: 8 }}
                        onClick={sendWhatsAppMessage}
                        endIcon={isSending ? <CircularProgress /> : <Icon>send</Icon>}
                    >
                        Send
                    </Button>
                </div>
            </Container>
        </Paper>
    );
};

const mapStateToProps = ({ categoryState, locationState }) => ({
    categories: categoryState.categories
});

export default connect(mapStateToProps)(WhatsAppScreenForm);